export default "__VITE_ASSET__rFoFhDVL__"